import { LANG_EXTEND } from '@/components/Vcms/HeaderBar/desktop';
import { SEO_PAGE_TYPE } from '@/utils/constants';
import { useAppSelector } from '@/utils/hook';
import { get, uniqueId } from 'lodash';
import Head from 'next/head';
import React from 'react';

interface CompanyPageMetaHeaderProps {
  branchPage: any,
  path: string;
  route: any,
}

const CompanyPageMetaHeader: React.FC<CompanyPageMetaHeaderProps> = ({ branchPage, path, route }) => {
  const goyoloSeo = useAppSelector((state) => state.goyoloSeo);
  if (!goyoloSeo || !goyoloSeo?.templateData) {
    return null;
  }

  const seoData = goyoloSeo?.templateData?.attributes?.seo || {
    metaTitle: null,
    metaDescription: null,
    canonicalURL: null,
    metaImage: null,
    structuredData: null,
  };
  const lang = goyoloSeo?.lang;
  const airport = goyoloSeo?.calculatedParams?.airport;
  const airportLocaleNext = (airport?.localizations?.data || []).find((a: { locale: string; }) => a?.locale !== lang?.lang)?.attributes?.slug;
  const airportLocale = airport?.slug;
  const {
    metaTitle, metaDescription, canonicalURL, metaImage, structuredData,
  } = seoData;
  let imageUrl = process.env.NEXT_PUBLIC_LOGO_LINK;
  let imageAlternativeText = `Goyolo.com săn vé máy bay ${branchPage?.name} giá rẻ`;
  if (metaImage) {
    imageUrl = get(metaImage, 'data.attributes.url') || imageUrl;
    imageAlternativeText = get(metaImage, 'data.attributes.alternativeText') || imageAlternativeText;
  }

  let url = canonicalURL || (`${process.env.GOYOLO_URL || ''}${path}`);
  const brandName = (goyoloSeo?.templateData?.attributes?.customAttributes || []).find((attr) => attr.name === 'brandName');
  let alternateEn = '';
  let alternateVn = '';
  url = url.replace('.en.en', '.en').replace('.en-', '-').replace('.vi-', '-');
  switch (route.lang) {
    case LANG_EXTEND.vi:
      alternateVn = url;
      alternateEn = url.replace('ve-may-bay', 'flights').replace('-tu-', '-from-').replace('-di-', '-to-').replace('/tu-', '/from-')
        .replace('/di-', '/to-')
        .replace('.vi', '.en')
        .replace(airportLocale, airportLocaleNext);
      break;
    case LANG_EXTEND.en:
      alternateEn = url;
      alternateVn = url.replace('flights', 've-may-bay').replace('-from-', '-tu-').replace('-to-', '-di-').replace('/from-', '/tu-')
        .replace('/to-', '/di-')
        .replace('.en', '.vi')
        .replace(airportLocale, airportLocaleNext);
      break;
    default:
      alternateVn = url;
      alternateEn = url.replace('ve-may-bay', 'flights').replace('-tu-', '-from-').replace('-di-', '-to-').replace('/tu-', '/from-')
        .replace('/di-', '/to-')
        .replace('.vi', '.en')
        .replace(airportLocale, airportLocaleNext);
  }

  url = url.replace('https://goyolo.com', '');

  return (
    <Head>
      <title>{metaTitle || ''}</title>
      <meta
        name="description"
        content={metaDescription || ''}
      />
      <meta
        name="google-site-verification"
        content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION}
      />
      <meta
        name="og:type"
        property="og:type"
        content="Product"
      />
      <meta
        name="og:title"
        property="og:title"
        content={metaTitle || ''}
      />
      <meta
        name="og:description"
        property="og:description"
        content={metaDescription || ''}
      />
      <meta
        name="og:image"
        property="og:image"
        content={imageUrl}
      />
      {/* <link
        rel="shortcut icon"
        href="https://vexere.com/images/vexere-ico.ico?v=0.0.3"
      /> */}
      <meta
        name="og:image:alt"
        property="og:image:alt"
        content={imageAlternativeText}
      />
      <meta
        name="og:locale"
        property="og:locale"
        content="vi"
      />
      <meta
        name="og:url"
        property="og:url"
        content={url}
      />
      <meta
        name="og:site_name"
        property="og:site_name"
        content={(brandName && brandName.value) ? brandName.value : 'Goyolo.com'}
      />
      <meta
        name="fb:app_id"
        property="fb:app_id"
        content="https://www.facebook.com/Goyolocom-103117924769137"
      />
      <link
        rel="alternate"
        type="text/html"
        href={alternateVn}
        hrefLang="vi"
        title="Tiếng Việt"
      />
      <link
        rel="alternate"
        type="text/html"
        href={alternateEn}
        hrefLang="en"
        title="English"
      />
      <link
        rel="canonical"
        href={url}
      />
      {(structuredData || []).map((jsonObj) => (
        <script
          key={uniqueId()}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonObj) }}
        />
      ))}
    </Head>
  );
};

export default CompanyPageMetaHeader;
